import React, { PropTypes } from 'react';

import ProgressStep from './ProgressStep';
import 'rc-slider/assets/index.css';
import '../controls.scss';

const ProgressBar = (props) => {
  const stepWidth = 100 / props.tilesLoaded.length;
  const steps = props.tilesLoaded.map((tile, index) =>
    <ProgressStep
      key={index}
      loaded={tile}
      width={stepWidth}
      prognose={props.prognose}
      step={index}
    />);

  return (
    <div className="mt-slider-progress-track">
      {steps}
    </div>
  );
};

ProgressBar.propTypes = {
  tilesLoadStatus: PropTypes.number
};

export default ProgressBar;



/** WEBPACK FOOTER **
 ** ./core_components/TimingHandler/TimeNavigation/controls/ProgressBar.js
 **/